/**
 * @author 3173
 * @description 岗位能力管理
 * @Date  2020/7/17
 */
import React from "react";
import {connect} from "dva";
import {component_tool, framework_tool, utils_tool} from '../../../../tool';
//import {PositionSelectOrgList} from  '../../../org/position/positionEdit/positionSelectOrgList'// '../../../../org/position/positionSelectOrg/positionSelectOrg'
import StudentAbilityItemForm from './studentAbilityItemForm'

let {WizContainer, modelUtils} = framework_tool;
let {WizCard, WizForm, WizSpin} = component_tool;
let {Session} = utils_tool


class StudentAbilityItemDetail extends WizContainer {
  componentName = 'studentAbilityItemDetail';

  constructor(props) {
    super(props);
    const {history} = this.props;
    let initialValue = {};
    let positionState = 1;
    let cardTitle = '新增';
    // if (history.location && history.location.pathname === '/train/abilityCheckCategory/categoryDetailUpd') {
    //   if (history.location && history.location.record) {
    //     initialValue = history.location.record;
    //     positionState = initialValue.state;
    //     Session.set('categoryDetailUpd', initialValue)
    //   } else {
    //     initialValue = Session.get('categoryDetailUpd') || {};
    //   }
    //   cardTitle = '编辑'
    // }
    this.state = {
      cardTitle: cardTitle,
      abilityItemsInfo: [], //能力项
      hasPersonIdList: [],//已有能力评估星级的人员
    }
    this.initialValue = initialValue;
  }


  _componentDidMount() {

  }


  propsAndStateOnChange = {
    saveStudentAbilityItem: this._saveStudentAbilityItemOver.bind(this),
    abilityItemList: this.getAbilityItemListOver.bind(this),
    hasPersonIdList: this.getStudentAbilityItemPersonIdListOver.bind(this)
  }

  /** 获取能力项 */
  getNextNeedData(abilityCheckItemId, abilityCheckCategoryId) {
    this.doActions([
      {
        path: 'abilityItemDetail/listItemsByCondition',
        payload: {
          key: 'abilityItemList',
          apiParams: {
            abilityCheckItemId: abilityCheckItemId,
            abilityCheckCategoryId: abilityCheckCategoryId
          }
        },
      }
    ])
  }

  /** 获取能力评估星级人员集合 */
  getNextNeedPersonIdListData(abilityCheckItemId) {
    this.doActions([
      {
        path: 'studentAbilityItem/getStudentAbilityItemPersonIdList',
        payload: {
          key: 'hasPersonIdList',
          apiParams: {
            id: abilityCheckItemId
          }
        },
      }
    ])
  }


  _saveStudentAbilityItemOver(nextProps, nextState) {
    if (nextProps.saveStudentAbilityItem.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/train/studentAbilityList');
    } else {
      wizNotice.error('提交失败：' + nextProps.saveStudentAbilityItem.msg);
    }
    return true;
  }


  getAbilityItemListOver(nextProps, nextState) {
    let _list = [];
    if (nextProps['abilityItemList'] && nextProps['abilityItemList']['success'] === true) {
      let list = nextProps["abilityItemList"]['data'];
      list && list.forEach(val => {
        _list.push({
          abilityItemDetailId: val['id'],
          abilityCheckItemId: val['abilityCheckItemId'],
          abilityItemId: val['abilityItemId'],
          abilityCheckCategoryId: val['abilityCheckCategoryId'],
          state: val['state'],
          key: val['abilityItemId'],
          name: val['abilityItemName'],
          target: val['score'],
          exhibition: val['exhibition']
        })
      });
      nextState.abilityItemsInfo = _list;
      return true;
    } else {
      wizNotice.error(nextProps["abilityItemList"]['msg']);
      return false;
    }
  }

  getStudentAbilityItemPersonIdListOver(nextProps, nextState) {
    let _list = [];
    if (nextProps['hasPersonIdList'] && nextProps['hasPersonIdList']['success'] === true) {
      let list = nextProps["hasPersonIdList"]['data'];
      list && list.forEach(val => {
        _list.push(val)
      });
      nextState.hasPersonIdList = _list;
      return true;
    } else {
      wizNotice.error(nextProps["hasPersonIdList"]['msg']);
      return false;
    }
  }


  /**
   * 保存/更新
   * @param values
   * @private
   */
  _saveStudentAbilityItem(values) {
    const {history} = this.props;
    let apiPath = "studentAbilityItem/add";
    // if (this.initialValue.id) {
    //   apiPath = "abilityCheckCategory/update"
    // }
    if (values.checkTime) {
      values.checkTime = new Date(values.checkTime).getTime();
    }  
    if (values.positionIds  && values.positionIds instanceof Array) {
      let ids = ''
      values.positionIds.forEach(e => {
        ids += e + ','
      })
      ids = ids.substring(0,ids.length-1)
      values.positionIds = ids
    } 
    if (values.list && values.personId) {
      // values.list.forEach(e => {
      //   e.personId = values.personId
      // })
      for(let i=0;i<values.list.length;i++){
        if(!values.list[i].score && values.list[i].score!==0){
          wizNotice.warn("能力值 "+values.list[i].name+" 不能为空");
          return;
        }
        values.list[i].personId = values.personId;
      }
    }

    this.doAction({
      path: apiPath,
      payload: {
        key: "saveStudentAbilityItem",
        apiParams: {
          ...values
        }
      }
    });
  }


  _render() {
    const {abilityCheckCategoryLoading, abilityItemDetailLoading, studentAbilityItemLoading} = this.props;
    let {cardTitle} = this.state;

    let onSubmit = this._saveStudentAbilityItem.bind(this);

    return <WizCard>
      <WizSpin tip={'加载中'}
               spinning={abilityCheckCategoryLoading || abilityItemDetailLoading || studentAbilityItemLoading}>
        <StudentAbilityItemForm className={'form-inline'} hasPersonIdList={this.state.hasPersonIdList}
                                abilityItemsInfo={this.state.abilityItemsInfo}
                                getNextNeedPersonIdListData={this.getNextNeedPersonIdListData.bind(this)}
                                getNextNeedData={this.getNextNeedData.bind(this)}
                                onSubmit={this._saveStudentAbilityItem.bind(this)}/>
      </WizSpin>
    </WizCard>
  }
}

const mapStateToProps = (state, ownProps) => {
  const {abilityCheckCategory, abilityItemDetail, studentAbilityItem} = state;
  const saveStudentAbilityItem = modelUtils.getModelEntity(studentAbilityItem, "saveStudentAbilityItem");
  const abilityItemList = modelUtils.getModelEntity(abilityItemDetail, "abilityItemList");
  const hasPersonIdList = modelUtils.getModelEntity(studentAbilityItem, "hasPersonIdList");
  const load = modelUtils.getLoadingState(state, ['abilityCheckCategory', 'abilityItemDetail', 'studentAbilityItem']);
  return {
    abilityItemList,
    saveStudentAbilityItem,
    hasPersonIdList,
    ...load
  }
};

export default connect(mapStateToProps)(StudentAbilityItemDetail);
